module.exports = __webpack_public_path__ + "img/beianIcon.58f55c5c.png";